import React, { useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import sendAnalyticsEvent from 'utils/sendAnalyticsEvent';
import { trackPixel } from 'utils/trackEvent';
import '../assets/scss/thank-page.scss';

// Real post-payment page. Polar redirects the browser here after checkout, so it
// is a genuine page load with its own URL (/subscription-success/:quizId) — GA4's
// config tag fires a normal page_view on load, no virtual pageview needed. This
// mirrors the quiz steps, where the URL in the address bar matches exactly what
// analytics records (no phantom /subscription-success label anymore).
const SubscriptionSuccess = () => {
    const { quizId } = useParams();
    // Fire the conversion pixels exactly once, even under React 18 StrictMode's
    // double-invoke (the ref survives the remount, unlike a fresh render).
    const fired = useRef(false);

    useEffect(() => {
        if (fired.current) return;
        fired.current = true;

        sendAnalyticsEvent({
            eventName: 'payment_completed',
            data: { quiz_id: quizId, source: 'quiz_funnel' },
        });
        // Meta: free-trial subscription started. The actual paid conversion
        // (trial -> paid) is the source of truth in the Polar webhook; a
        // server-side Purchase via the Conversions API is the next step.
        trackPixel('track', 'StartTrial', { currency: 'USD', value: 0 });
    }, [quizId]);

    return (
        <div className="thank-page">
            <div className="thank-page__container">
                <div className="thank-page__check">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#008558" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                </div>

                <h1 className="thank-page__heading">Payment successful</h1>
                <p className="thank-page__subtext">
                    Thank you for investing in yourself. Your behavioral profile is being prepared.
                </p>

                <div className="thank-page__card">
                    <h3 className="thank-page__card-title">What happens next</h3>
                    <ul className="thank-page__steps">
                        <li>
                            <span className="thank-page__step-num">1</span>
                            <span>Check your email for a secure login link</span>
                        </li>
                        <li>
                            <span className="thank-page__step-num">2</span>
                            <span>Click the link to access your dashboard</span>
                        </li>
                        <li>
                            <span className="thank-page__step-num">3</span>
                            <span>Explore your full behavioral diagnostic report</span>
                        </li>
                    </ul>
                </div>

                <p className="thank-page__note">
                    Didn't receive the email? Check your spam folder or{' '}
                    <Link to="/login">log in manually</Link>.
                </p>

                <Link to="/" className="thank-page__home-link">
                    Back to home
                </Link>
            </div>
        </div>
    );
};

export default SubscriptionSuccess;
